module.exports = __webpack_public_path__ + "img/artoftravel.d2d68327.jpg";